module.exports = __webpack_public_path__ + "img/self-diagnosis-people.fae33d5c.png";